import { connect } from 'react-redux';

// models
import { StateModel } from '../../core/models/state.model';
import { ClientModel } from '../../core/models/client.model';

interface AddModalProps {
	client: ClientModel;
}

function LotteryCouponInfoModal({ client }: AddModalProps) {
	return (
		<img
			className='max-h-[85vh] mx-auto aspect-[0.507]'
			src={client.lotteryCouponInfo?.urlImage}
			alt='Lottery Coupon Info'
		/>
	);
}

const mapStateToProps = (state: StateModel) => ({
	client: state.client,
});

export default connect(mapStateToProps)(LotteryCouponInfoModal);
